<template>
  <div class="home min-h-screen">
    <el-container id="container" class="bg-gray-200 items-start min-h-screen">
      <div
        @click="toggleNav"
        class="sm:hidden"
        :class="{
          'bg-black bg-opacity-30 z-20  w-full h-full absolute': navbar,
        }"
      >
        <div
          class="
            fixed
            z-30
            cursor-pointer
            w-10
            h-10
            top-4
            bg-white
            shadow-md
            rounded-full
            flex
            items-center
            justify-center
          "
          :class="{
            'left-4 right-auto	': navbar,
            'right-6': $i18n.locale == 'fa',
            'left-6': $i18n.locale != 'fa',
          }"
        >
          <i v-if="navbar" class="el-icon-close text-2xl text-carpo"></i>
          <svg
            version="1.1"
            id="Capa_1"
            v-if="!navbar"
            class=""
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="20"
            height="20"
            fill="#ff5604"
            viewBox="0 0 384.97 384.97"
            style="enable-background: new 0 0 384.97 384.97"
            xml:space="preserve"
          >
            <g>
              <g id="Menu">
                <path
                  d="M12.03,84.212h360.909c6.641,0,12.03-5.39,12.03-12.03c0-6.641-5.39-12.03-12.03-12.03H12.03
			C5.39,60.152,0,65.541,0,72.182C0,78.823,5.39,84.212,12.03,84.212z"
                />
                <path
                  d="M372.939,180.455H12.03c-6.641,0-12.03,5.39-12.03,12.03s5.39,12.03,12.03,12.03h360.909c6.641,0,12.03-5.39,12.03-12.03
			S379.58,180.455,372.939,180.455z"
                />
                <path
                  d="M372.939,300.758H12.03c-6.641,0-12.03,5.39-12.03,12.03c0,6.641,5.39,12.03,12.03,12.03h360.909
			c6.641,0,12.03-5.39,12.03-12.03C384.97,306.147,379.58,300.758,372.939,300.758z"
                />
              </g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
            </g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
          </svg>
        </div>
      </div>
      <sidebar />
      <dashboard />
    </el-container>
  </div>
</template>

<script>
import dashboard from '@/components/DashboardLayout.vue'
import sidebar from '@/components/elements/sidebar.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'Home',
  components: {
    dashboard,
    sidebar,
  },
  data() {
    return {
      newNavbar: false,
    }
  },
  methods: {
    toggleNav() {
      this.$store.commit('OPEN_NAVBAR', !this.navbar)
      if (this.navbar) {
        document.body.classList.add('overflow-y-hidden')
      } else {
        document.body.classList.remove('overflow-y-hidden')
      }
    },
  },
  computed: {
    ...mapGetters(['navbar']),
  },
  mounted() {
    if (this.$route.path == '/') {
      this.$router.push('/' + this.$i18n.locale + '/dashboard')
    }
  },
}
</script>

<style scoped>
.z-zero {
  z-index: -1;
}

.z-20 {
  z-index: 20;
}
</style>
